export const keys = {
  DOWN: 40,
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  RIGHT: 39,
  SHIFT: 16,
  SLASH: 191,
  SPACE: 32,
  TAB: 9,
  UP: 38
}

export const match = (eventOrCode: KeyboardEvent, key: number) => {
  return eventOrCode.which === key || eventOrCode.key === String(key)
}

export const isShiftSlash = (event) => event.shiftKey && event.code === 'Slash'
